export class LimeError extends Error {
    constructor({ code, description }) {
        super(description);
        this.name = this.constructor.name;
        this.description = description;
        this.code = code;
        this.message = `Cód. ${this.code}: ${description}`;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error(description).stack;
        }
    }
}
